/**
 * Registry of actions that have a wizard. Actions not listed here show a
 * "coming soon" placeholder. To add one, create a module that exports:
 *   id, steps, summary(answers, court), build(answers, court)
 * and, if it asks what kind of case it is, caseFacts ({ from, to }: see src/cases.js),
 * and, for a wizard built on the statewide base, statewide = true
 * and, for a wizard built on rules and steps (<id>.steps.json, lib/rulebook.js), rulebook
 * and register it below.
 */
import * as motionToQuash from "./motion-to-quash-subpoena.js";
import * as complaint from "./complaint.js";
import * as serviceOfSummons from "./service-of-summons.js";
import * as answer from "./answer.js";
import * as caseManagementStatement from "./case-management-statement.js";
import * as requestForDismissal from "./request-for-dismissal.js";

export const WIZARDS = {
  [motionToQuash.id]: motionToQuash,
  [complaint.id]: complaint,
  [serviceOfSummons.id]: serviceOfSummons,
  [answer.id]: answer,
  [caseManagementStatement.id]: caseManagementStatement,
  [requestForDismissal.id]: requestForDismissal,
};
